<script>
import Layout from "../../../layouts/auth";
import appConfig from "@/app.config";
import OtpInput from "@/components/otp";
import { EMAIL_TO, OTP_CHECK } from "@/services/api/auth";
import moment from "moment";

export default {
  page: {
    title: "Lupa Kata Sandi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    OtpInput,
  },
  data() {
    return {
      email: localStorage.getItem('emailOTP'),
      resend: false,
      timer: 0,
      otp: null,
      otpError: false,
      otpEmpty: false,
      otpWrong: false,
    };
  },
  created() {
    if(localStorage.getItem('timerOTP')){
      const now = moment().toISOString();
      if(moment(now).isSameOrBefore(localStorage.getItem('timerOTP'), 'minute')){
        this.timer = parseInt(moment(localStorage.getItem('timerOTP')).diff(now, 'minute'));
        this.resend = true;
        this.countDownTimer();
      } else {
        this.resend = false;
        localStorage.removeItem('timerOTP');
        this.timer = 0;
      }
    }
  },
  methods: {
    submitOTP() {
      if (this.otp != null) {
        if (this.otp.toString().length == 0) {
          this.otpError = true; 
          this.otpEmpty = true;
        } else {
          const input = {
          email: this.email,
          otp: this.otp,
        };
        this.$apollo
          .mutate({
            mutation: OTP_CHECK,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (
              response.data.checkingOtpPassword.checkingOtpPassword.message ==
              "failed otp password"
            ) {
              this.$toast.error("Kode verifikasi tidak sesuai");
              this.otpError = true;
              this.otpWrong = true;
            } else {
              this.$toast.success("Kode verifikasi sesuai");
              localStorage.setItem('otpCode', this.otp);
              this.$store.commit("resetPassword/SET_OTP", this.otp);
              this.$router.push({ name: "Reset Password" });
            }
          }); 
        }
      } else {
        this.otpError = true;
        this.otpEmpty = true;
      }
    },
    handleOnComplete(value) {

      this.otp = value;
      this.otpError = false;
      this.otpEmpty = false;
    },
    handleOnChange(value) {
      this.otp = value;
      if(this.otp == null) this.otpError = true;
      this.otpError = false;
      this.otpEmpty = false;
      this.otpWrong = false;
    },
    countDownTimer() {
      if (this.timer > 0) {
        setTimeout(() => {
          this.timer -= 1;
          this.countDownTimer();
        }, 60000);
      } else {
        this.resend = false;
        this.timer = 10;
      }
    },
    resendOTP() {
      this.resend = true;
      this.otpError = false;
      const input = {
        email: this.email,
      };
      this.$apollo
        .mutate({
          mutation: EMAIL_TO,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (
            response.data.emailForgotPassword.emailForgotPassword.message ==
            "failed to get email"
          ) {
            this.$toast.error("Email tidak terdaftar");
          } else {
            localStorage.setItem('timerOTP', moment().add(10, 'minute').toISOString());
            this.timer = 10;
            this.resend = true;
            this.countDownTimer();
          }
        });
    },
  },
};
</script>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo mb-0 pt-5">
        <router-link to="/">
          <img src="@/assets/images/main-logo.png" alt />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <h4 class="mc-auth__label">Kode Verifikasi</h4>
        <p class="mb-1">Masukkan kode verifikasi yang kami kirimkan ke email</p>
        <p><strong>{{ email }}</strong></p>
        <OtpInput
          ref="otpInput1"
          :input-classes="otpError ? 'mc-otp-input error':'mc-otp-input'"
          separator=""
          :num-inputs="6"
          :should-auto-focus="true"
          input-type="number"
          @on-complete="handleOnComplete"
          @on-change="handleOnChange"
        />
        
        <div v-if="otpError" class="invalid-feedback d-flex justify-content-center mt-2">
          <span v-if="otpEmpty">Kode verifikasi tidak boleh kosong.</span>  
          <span v-if="otpWrong">Kode verifikasi salah.</span>  
        </div>
        <div class="mt-5">
          <b-button
            type="submit"
            variant="primary"
            class="w-100"
            @click="submitOTP"
            >Verifikasi</b-button
          >
          <a v-if="resend" class="text-secondary d-block my-3"
            >Kirim Ulang dalam {{timer}} menit</a
          >
          <a
            class="text-primary mt-3 d-block"
            @click="resendOTP"
            v-else
            >Kirim Ulang</a
          >
          <p class="mt-5">
            Salah memasukkan email ?
            <a
              class="text-primary"
              @click="$router.push({ name: 'Forgot Password' })"
              >Kembali halaman sebelumnya</a
            >
          </p>
        </div>
      </div>
      <div class="mc-auth__copyright">
          <span
            >Dipersembahkan oleh
            <img
              src="@/assets/images/copyright-logo.png"
              alt
              height="18"
              class="ms-2"
          /></span>
        </div>
    </div>
  </Layout>
</template>
